// TODO: deprecated — only consumed by the legacy FileModal via APIProviders.
// FileModal is no longer triggered by any call site (replaced by AddImageModal
// / library panel). Safe to delete with FileModal cleanup.
import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import {
  Button,
  Row,
  Col,
  Container,
  FormGroup,
  FormControl,
  ButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import AppModal from "../../../../common/modal/AppModal";
import CodePreview from "./CodePreview";
import Select from "react-select";
import "../../../../nav_bar/global_config/_reactTags.scss";
import Alert from "../../../../common/alert/Alert";
import { extensionHandlers as extensions } from "../../FileHandlers/FileHandlers";
import { credentialsFor } from "../../../../../../common/utils";
// import VideoThumbnail from 'react-video-thumbnail'; // Disabled for React 19 compatibility
import "react-dropdown-tree-select/dist/styles.css";
import "./dropdowntree.css";
import DropdownContainer from "./DropdownContainer";

class LazyVideoThumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      thumbnailSrc: null,
      hasError: false,
    };
    this.elementRef = React.createRef();
    this.observer = null;
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.state.isVisible) {
            this.setState({ isVisible: true });
            this.generateThumbnail();
          }
        });
      },
      {
        root: null,
        rootMargin: "50px",
        threshold: 0.1,
      }
    );

    if (this.elementRef.current) {
      this.observer.observe(this.elementRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer && this.elementRef.current) {
      this.observer.unobserve(this.elementRef.current);
    }
  }

  generateThumbnail() {
    if (this.state.thumbnailSrc || this.state.hasError) {
      return;
    }

    const video = document.createElement("video");
    video.crossOrigin = credentialsFor(this.props.videoUrl).credentials
      ? "use-credentials"
      : "anonymous";
    video.currentTime = 1;

    video.onloadeddata = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = this.props.width;
        canvas.height = this.props.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const thumbnailSrc = canvas.toDataURL();
        this.setState({ thumbnailSrc });
      } catch (error) {
        this.setState({ hasError: true });
      }
    };

    video.onerror = () => {
      this.setState({ hasError: true });
    };

    video.src = this.props.videoUrl;
  }

  render() {
    const { width, height } = this.props;
    const { isVisible, thumbnailSrc, hasError } = this.state;

    return (
      <div
        ref={this.elementRef}
        style={{ width, height, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {isVisible && thumbnailSrc && !hasError ? (
          <img
            src={thumbnailSrc}
            width={width}
            height={height}
            style={{ objectFit: "cover", borderRadius: "4px" }}
            alt="Video thumbnail"
          />
        ) : (
          <div
            style={{
              width,
              height,
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
            }}
          >
            <i className="material-icons" style={{ color: "#bbb", fontSize: "24px" }}>
              {hasError ? "error_outline" : "play_arrow"}
            </i>
          </div>
        )}
      </div>
    );
  }
}

const data = [
  {
    label: "search me",
    value: "searchme",
    category: "1",
    children: [
      {
        label: "search me too",
        value: "searchmetoo",
        category: "2",
        children: [
          {
            label: "No one can get me",
            value: "anonymous",
            category: "3",
          },
        ],
      },
    ],
  },
  {
    label: "asdas me",
    value: "searasdaschme",
    category: "2",
    children: [
      {
        label: "search me asda",
        value: "searchmetasdsaoo",
        category: "3",
        children: [
          {
            label: "No one can get asdsa",
            value: "asdas",
            category: "3",
          },
        ],
      },
    ],
  },
  {
    label: "search me",
    value: "searchme",
    category: "1",
    children: [
      {
        label: "search me too",
        value: "searchmetoo",
        category: "2",
        children: [
          {
            label: "No one can get me",
            value: "anonymous",
            category: "3",
          },
        ],
      },
      {
        label: "search me asdas",
        value: "searchmetoo",
        children: [
          {
            label: "No one can get me",
            value: "anonymous",
          },
        ],
      },
    ],
  },
  {
    label: "asdas me",
    value: "searasdaschme",
    children: [
      {
        label: "search me asda",
        value: "searchmetasdsaoo",
        children: [
          {
            label: "No one can get asdsa",
            value: "asdas",
          },
        ],
      },
    ],
  },
  {
    label: "search me",
    value: "searchme",
    children: [
      {
        label: "search me too",
        value: "searchmetoo",
        children: [
          {
            label: "No one can get me",
            value: "anonymous",
          },
        ],
      },
    ],
  },
  {
    label: "asdas me",
    value: "searasdaschme",
    children: [
      {
        label: "search me asda",
        value: "searchmetasdsaoo",
        children: [
          {
            label: "No one can get asdsa",
            value: "asdas",
          },
        ],
      },
    ],
  },
];

let filess = [
  {
    id: "file-1654602192220",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/baklava.png",
    name: "yanKare",
    keywords: "",
    mimetype: "image/png",
    category: "1",
  },
  {
    id: "file-1654404192238",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/daire.png",
    name: "daire",
    keywords: "",
    mimetype: "image/png",
    category: "1",
  },
  {
    id: "file-1656604192240",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/dikbirdikdortgen.png",
    name: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non nobis, facere magnam nesciunt eum adipisci enim nulla libero iure expedita? Voluptas fuga voluptate repudiandae nisi officiis animi laboriosam quo distinctio?",
    keywords: "",
    mimetype: "image/png",
    category: "1",
  },
  {
    id: "file-1654604192241",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/dikdortgen.png",
    name: "dikdörtgen",
    keywords: "",
    mimetype: "image/png",
    category: "1",
  },
  {
    id: "file-167465192242",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/kare.png",
    name: "kare",
    keywords: "",
    mimetype: "image/png",
    category: "1",
  },
  {
    id: "file-1954604192243",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Sekiller/ucgen.png",
    name: "üçgen",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192239",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek1.png",
    name: "erkek1",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192238",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek2.png",
    name: "erkek2",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192251",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek3.png",
    name: "erkek3",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192240",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek4.png",
    name: "erkek4",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192241",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek5.png",
    name: "erkek5",
    keywords: "",
    mimetype: "image/png",
    category: "2",
  },
  {
    id: "file-1654604192242",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek6.png",
    name: "erkek6",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192243",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/erkek7.png",
    name: "erkek7",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192244",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin1.png",
    name: "kadin1",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192245",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin2.png",
    name: "kadin2",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192246",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin3.png",
    name: "kadin3",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192247",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin4.png",
    name: "kadin4",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192248",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin5.png",
    name: "kadin5",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192249",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin6.png",
    name: "kadin6",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
  {
    id: "file-1654604192250",
    url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Karakter/kadin7.png",
    name: "kadin7",
    keywords: "",
    mimetype: "image/png",
    category: "3",
  },
];
export default class MyFilesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: undefined,
      filter: "",
      extensionFilter: this.props.show,
      keywords: [],
      confirmDelete: false,
      deleteAllFile: false,
      errorDeleteAlert: false,
      getFiles: [],
      warehouseFiles: [],
      menu: 1,
      checked: false,
      radioValue: 1,
    };
    this.files = null;
    this.files2 = null;
    this.generatePreview = this.generatePreview.bind(this);
    // #region DropdownTreeSelect Action
    this.onChange = (currentNode, selectedNodes) => {
      this.setState({ getFiles: [] });
      let warehouseFiles = this.files.concat(this.files2);
      let a = [];
      warehouseFiles.map((e) => {
        if (e && selectedNodes.length) {
          if (e.category == selectedNodes[0].category) {
            return a.push(e);
          }
          // return a.push(e);
        }
      });
      this.setState({ getFiles: a });
    };

    //  this.setState({getFiles : files.concat(files2)})

    /* const onAction = (node, action) => {
             console.log('onAction::', action, node);
         };
         const onNodeToggle = currentNode => {

             console.log('onNodeToggle::', currentNode);
         };*/
    // #endregion
  }

  render() {
    let empty = true;
    this.files = Object.keys(this.props.filesUploaded).map((f) => {
      let file = this.props.filesUploaded[f];
      let type = file.mimetype;
      let icon = "attach_file";
      for (let e in extensions) {
        let ext = extensions[e];

        if (ext.value !== "" && type.match(ext.value)) {
          type = ext.value;
          icon = ext.icon;
        }
      }
      let re0 = new RegExp(this.state.filter, "gi");
      if (
        ((file.name && file.name.match(re0)) ||
          (file.mimetype && file.mimetype.match(this.state.filter))) && // Matches written filter
        (this.state.extensionFilter === "*" ||
          (file.mimetype && file.mimetype.match(this.state.extensionFilter))) // Matches extension filter
      ) {
        empty = false;
        return { ...file, type, icon };
      }

      return { ...file, type, icon, hide: true };
    });

    // this.files.reverse();

    this.files2 = filess.map((f) => {
      let file = f;
      let type = file.mimetype;
      let icon = "attach_file";
      for (let e in extensions) {
        let ext = extensions[e];

        if (ext.value !== "" && type.match(ext.value)) {
          type = ext.value;
          icon = ext.icon;
        }
      }
      let re1 = new RegExp(this.state.filter, "gi");
      if (
        ((file.name && file.name.match(re1)) ||
          (file.mimetype && file.mimetype.match(this.state.filter))) && // Matches written filter
        (this.state.extensionFilter === "*" ||
          (file.mimetype && file.mimetype.match(this.state.extensionFilter))) // Matches extension filter
      ) {
        empty = false;
        return { ...file, type, icon };
      }

      return { ...file, type, icon, hide: true };
    });

    let warehouseFiles = this.state.getFiles.map((f) => {
      let file = f;
      let type = file.mimetype;
      let icon = "attach_file";
      for (let e in extensions) {
        let ext = extensions[e];

        if (ext.value !== "" && type.match(ext.value)) {
          type = ext.value;
          icon = ext.icon;
        }
      }
      let re = new RegExp(this.state.filter, "gi");
      if (
        ((file.name && file.name.match(re)) ||
          (file.mimetype && file.mimetype.match(this.state.filter))) && // Matches written filter
        (this.state.extensionFilter === "*" ||
          (file.mimetype && file.mimetype.match(this.state.extensionFilter))) // Matches extension filter
      ) {
        empty = false;
        return { ...file, type, icon };
      }

      return { ...file, type, icon, hide: true };
    });
    let currentExtension = this.props.show === "*" ? this.state.extensionFilter : this.props.show;
    currentExtension = currentExtension === "*" ? "" : currentExtension;
    let aux = currentExtension;
    for (let e in extensions) {
      let ext = extensions[e];
      if (currentExtension.match(ext.value)) {
        aux = ext.value;
      }
    }
    currentExtension = aux;
    let fileSelected = this.props.filesUploaded[this.props.idSelected];
    let download = {
      // Forces browser download
      title: i18n.t("FileModal.FileHandlers.downloadAsFile"),
      disabled: !fileSelected,
      action: () => {
        //window.download(fileSelected.url, fileSelected.name);
        window.open(fileSelected.url);
      },
    };

    const radios = [
      { name: "Izgara", value: "1" },
      { name: "Liste", value: "2" },
    ];

    /*  <h5>{this.props.icon ? <img className="fileMenuIcon" src={this.props.icon } alt=""/> : this.props.name}</h5> */
    return (
      <div className="contentComponent myFilesComponent">
        {/* <h5>{i18n.t("FileModal.APIProviders.MyFilesTitle")}</h5> */}
        {/*   <hr />
            <ButtonGroup className="sm-2" style={{ float: "right" }} >
                {radios.map((radio, idx) => (
                    <ToggleButton
                        key={idx}
                        id={`radio-${idx}`}
                        type="radio"
                        variant="secondary"
                        name="radio"
                        value={radio.value}
                        checked={this.state.radioValue === radio.value || this.state.radioValue === 1 && idx === 0}
                        onChange={(e) => this.setState({ radioValue: e.target.value })}
                    >
                        {radio.name == "Izgara" ? <svg xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: "-5px" }} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" /></svg>
                            :
                            <svg xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: "-5px" }} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z" /></svg>
                        }
                    </ToggleButton>
                ))}
            </ButtonGroup> */}

        {/* <DropdownContainer
                texts={{
                    placeholder: i18n.t('SelectAFolder'),
                }}
                className="mdl-demo"
                mode='radioSelect'
                data={data}
                onChange={this.onChange}
            // onAction={onAction}
            // onNodeToggle={onNodeToggle}
            /> */}
        {/* <hr /> */}
        <div className={"filters"}>
          <Col lg={this.props.show !== "*" ? 12 : 8} style={{ padding: "0px" }}>
            <FormGroup key="filter">
              <FormControl
                type="text"
                value={this.state.filter}
                placeholder={i18n.t("Filter")}
                id="filterInput"
                autoFocus
                onChange={(e) => {
                  this.setState({ filter: e.target.value });
                }}
              />
            </FormGroup>
          </Col>
          <Col
            lg={this.props.show !== "*" ? 0 : 4}
            hidden={this.props.show !== "*"}
            style={{ padding: "0px" }}
          >
            <FormGroup key="extfilter">
              <Select
                name="form-field-extensions"
                value={currentExtension}
                disabled={this.props.show !== "*"}
                options={Object.values(extensions)}
                className="selectD"
                onChange={(e) => {
                  this.setState({ extensionFilter: e.value });
                }}
              />
            </FormGroup>
          </Col>
        </div>
        <Container style={{ display: this.state.radioValue <= 1 ? "none" : null }}>
          {/* Title */}
          {/*  <Container style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid lightgrey", paddingBottom: "10px", textAlign: "center" }}>
                    <Col xs={6} md={3} style={{ alignItems: "center", display: "inline-grid", fontWeight: "bold", fontSize: "13px" }}>
                        <span> İÇERİK </span>
                    </Col>
                    <Col xs={6} md={5} style={{ alignItems: "center", display: "inline-grid", fontWeight: "bold", fontSize: "13px" }}>
                        <span> DOSYA ADI </span>
                    </Col>
                    <Col xs={6} md={2} style={{ alignItems: "center", display: "inline-grid", fontWeight: "bold", fontSize: "13px" }}>
                        <span> FORMAT </span>
                    </Col>
                    <Col xs={6} md={2} style={{ alignItems: "center", display: "inline-grid", fontWeight: "bold", fontSize: "13px" }}>
                        <span > KATEGORİ </span>
                    </Col>
                </Container> */}
          {/* Title End*/}
          {this.files.map((file, i) => {
            let split = file.name.split(".");
            let filetype = file.type; // ? file.type : ((split && (split.length > 1)? split[split.length-1]:'application'));
            let isActive = file.id === this.props.idSelected;
            // VideoThumbnail disabled for React 19 compatibility
            // let thumbnail = (
            //   <div
            //     style={{
            //       width: 80,
            //       height: 35,
            //       backgroundColor: "#f0f0f0",
            //       display: "flex",
            //       alignItems: "center",
            //       justifyContent: "center",
            //       border: "1px solid #ddd",
            //     }}
            //   >
            //     <i className="material-icons" style={{ fontSize: "16px", color: "#666" }}>
            //       play_arrow
            //     </i>
            //   </div>
            // );
            let thumbnail = (
              <LazyVideoThumbnail
                videoUrl={file.url}
                key={file.id + "-thumb-" + i}
                thumbnailHandler={(e) => e}
                width={80}
                height={35}
              />
            );
            return (
              <Container
                className="grid"
                style={{
                  display: file.hide ? "none" : "flex",
                  borderBottom: file.hide ? null : "2px solid lightgrey",
                  height: "80px",
                }}
              >
                <Col
                  key={i}
                  className={"myFile" + (file.hide ? " hidden" : "")}
                  xs={6}
                  md={3}
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    height: "80px",
                  }}
                >
                  {isActive ? (
                    <Button
                      style={{ height: "22px" }}
                      className="deleteButton"
                      onClick={(e) => {
                        this.setState({ confirmDelete: true });
                        e.stopPropagation();
                      }}
                    >
                      <i
                        style={{
                          fontSize: "1em",
                        }}
                        className="material-icons"
                      >
                        delete
                      </i>
                    </Button>
                  ) : null}
                  {isActive ? (
                    <Button
                      style={{ height: "22px" }}
                      className="downloadButton"
                      onClick={(e) => {
                        download.action();
                      }}
                    >
                      <i
                        style={{
                          fontSize: "1em",
                        }}
                        className="material-icons"
                      >
                        cloud_download
                      </i>
                    </Button>
                  ) : null}
                  {isActive && this.props.elementSelectedType !== "image" ? (
                    <Button
                      className="previewFileButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ preview: true });
                      }}
                    >
                      {this.props.elementSelectedType === "audio" ? (
                        <i className="material-icons">volume_down</i>
                      ) : (
                        <i className="material-icons">remove_red_eye</i>
                      )}
                    </Button>
                  ) : null}
                  <Button
                    style={{
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: filetype === "image" ? "url(" + file.url + ")" : "",
                      height: "80%",
                      width: "75%",
                    }}
                    onClick={(e) => {
                      this.props.onElementSelected(file.name, file.url, filetype, file.id);
                      e.stopPropagation();
                    }}
                    className={"myFileContent" + (isActive ? " active" : "")}
                  >
                    {file.type === "image" ? (
                      ""
                    ) : file.type === "video" ? (
                      ((<i className="material-icons">{file.icon || "attach_file"} </i>), thumbnail)
                    ) : (
                      <i className="material-icons">{file.icon || "attach_file"} </i>
                    )}
                  </Button>
                </Col>
                <Col
                  className={"myFile" + (file.hide ? " hidden" : "")}
                  xs={6}
                  md={5}
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    height: "80px",
                  }}
                >
                  <span
                    style={{
                      width: "100%",
                      display: "block",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                      fontSize: "13px",
                      verticalAlign: "middle",
                      lineHeight: "calc(130px *0.3)",
                    }}
                    title={file.name}
                  >
                    {file.name}
                  </span>
                </Col>
                <Col
                  className={"myFile" + (file.hide ? " hidden" : "")}
                  xs={6}
                  md={2}
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    height: "80px",
                  }}
                >
                  <span title={file.mimetype}>{file.mimetype}</span>
                </Col>
                <Col
                  className={"myFile" + (file.hide ? " hidden" : "")}
                  xs={6}
                  md={2}
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    height: "80px",
                  }}
                >
                  <span title={file.category}>{file.category}</span>
                </Col>
              </Container>
            );
          })}
        </Container>
        <Container style={{ display: this.state.radioValue >= 2 ? "none" : null }}>
          {/*  <Button className="deleteButton"
                    style={{ display: this.files.length >= 1 ? "" : "none", marginTop: "-1%", marginBottom: "1%", float: "right" }}
                    disabled={!(this.files.length >= 1)}
                    onClick={() => { this.setState({ deleteAllFile: true }); }} >
                    {i18n.t("FileModal.APIProviders.delete_all")}
                </Button> */}
          <Row
            className="myFilesRow"
            onClick={(e) => {
              this.setState({ preview: false });
              this.props.onElementSelected(undefined, undefined, undefined);
            }}
          >
            {this.files.map((file, i) => {
              let split = file.name.split(".");
              let filetype = file.type; // ? file.type : ((split && (split.length > 1)? split[split.length-1]:'application'));
              let isActive = file.id === this.props.idSelected;
              // VideoThumbnail disabled for React 19 compatibility
              // let thumbnail = (
              //   <div
              //     style={{
              //       width: 125,
              //       height: 80,
              //       backgroundColor: "#f0f0f0",
              //       display: "flex",
              //       alignItems: "center",
              //       justifyContent: "center",
              //       border: "1px solid #ddd",
              //     }}
              //   >
              //     <i className="material-icons" style={{ fontSize: "24px", color: "#666" }}>
              //       play_arrow
              //     </i>
              //   </div>
              // );
              let thumbnail = (
                <LazyVideoThumbnail
                  videoUrl={file.url}
                  key={file.id + "-thumb-" + i}
                  thumbnailHandler={(e) => e}
                  width={80}
                  height={35}
                />
              );
              return (
                <Col
                  style={{ height: "160px" }}
                  key={i}
                  className={"myFile" + (file.hide ? " hidden" : "")}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                >
                  {isActive ? (
                    <Button
                      className="deleteButton"
                      onClick={(e) => {
                        this.setState({ confirmDelete: true });
                        e.stopPropagation();
                      }}
                    >
                      <i className="material-icons">delete</i>
                    </Button>
                  ) : null}
                  {isActive ? (
                    <Button
                      className="downloadButton"
                      onClick={(e) => {
                        download.action();
                      }}
                    >
                      <i className="material-icons">cloud_download</i>
                    </Button>
                  ) : null}
                  {isActive && this.props.elementSelectedType !== "image" ? (
                    <Button
                      className="previewFileButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ preview: true });
                      }}
                    >
                      {this.props.elementSelectedType === "audio" ? (
                        <i className="material-icons">volume_down</i>
                      ) : (
                        <i className="material-icons">remove_red_eye</i>
                      )}
                    </Button>
                  ) : null}
                  <Button
                    style={{
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: filetype === "image" ? "url(" + file.url + ")" : "",
                    }}
                    onClick={(e) => {
                      this.props.onElementSelected(file.name, file.url, filetype, file.id);
                      e.stopPropagation();
                    }}
                    className={"myFileContent" + (isActive ? " active" : "")}
                  >
                    {file.type === "image" ? (
                      ""
                    ) : file.type === "video" ? (
                      ((<i className="material-icons">{file.icon || "attach_file"} </i>), thumbnail)
                    ) : (
                      <i className="material-icons">{file.icon || "attach_file"} </i>
                    )}
                  </Button>
                  <span className="ellipsis" title={file.name}>
                    {file.name}
                  </span>
                </Col>
              );
            })}
          </Row>
          {this.state.deleteAllFile ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    delete
                  </i>
                  {i18n.t("messages.confirm_delete_cv")}
                </span>
              }
              cancelButton
              acceptButtonText={i18n.t("messages.OK")}
              onClose={(bool) => {
                if (bool) {
                  this.files.map((file) => {
                    this.props.onElementSelected(undefined, undefined, undefined);
                    this.props.deleteFileFromServer(file.id, file.url, (status) => {
                      if (!status) {
                        this.setState({ errorDeleteAlert: true });
                      }
                    });
                  });
                }
                this.setState({ deleteAllFile: false });
              }}
            >
              <span> {i18n.t("FileModal.APIProviders.confirm_delete_all")} </span>
              <br />
            </Alert>
          ) : null}
          {this.state.confirmDelete ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    delete
                  </i>
                  {i18n.t("messages.confirm_delete_cv")}
                </span>
              }
              cancelButton
              acceptButtonText={i18n.t("messages.OK")}
              onClose={(bool) => {
                if (bool) {
                  this.props.onElementSelected(undefined, undefined, undefined);
                  this.props.deleteFileFromServer(
                    this.props.idSelected,
                    this.props.elementSelected,
                    (status) => {
                      if (!status) {
                        this.setState({ errorDeleteAlert: true });
                      }
                    }
                  );
                }
                this.setState({ confirmDelete: false });
              }}
            >
              <span> {i18n.t("FileModal.APIProviders.confirm_delete")} </span>
              <br />
            </Alert>
          ) : null}
          {empty ? <p className="empty">{i18n.t("FileModal.APIProviders.no_files")}</p> : null}
          {this.state.errorDeleteAlert ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              acceptButtonText={i18n.t("messages.OK")}
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    warning
                  </i>
                  {i18n.t("messages.error")}
                </span>
              }
              onClose={() => {
                this.setState({ errorDeleteAlert: false });
              }}
            >
              <span> {i18n.t("error.deleting")} </span>
              <br />
            </Alert>
          ) : null}
          <AppModal
            className="previewVideoModal"
            show={!!(this.state.preview && this.props.elementSelected)}
            onClose={() => this.setState({ preview: false })}
            title={i18n.t("Preview")}
          >
            {this.generatePreview()}
          </AppModal>
        </Container>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({ extensionFilter: nextProps.show });
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (
      nextProps.filesUploaded &&
      this.props.filesUploaded &&
      nextProps.filesUploaded.length !== this.props.filesUploaded.length
      /* || nextState.filter !== this.state.filter || nextState.extensionFilter !== this.state.extensionFilter*/
    ) {
      // this.props.onElementSelected( undefined, undefined, undefined);
    }
  }
  generatePreview() {
    let item = this.props.elementSelected;
    switch (this.props.elementSelectedType) {
      case "webapp":
      case "pdf":
      case "scormpackage":
        return (
          <iframe src={this.props.elementSelected} frameBorder="0" width={"100%"} height={"400"} />
        );
      case "image":
        return null;
      case "audio":
        return (
          <audio
            src={this.props.elementSelected}
            controls
            width={"100%"}
            height={"400"}
            style={{ width: "100%" }}
          />
        );
      case "video":
        return <video src={this.props.elementSelected} controls width={"100%"} height={"400"} />;
      case "swf":
        return (
          <embed src={this.props.elementSelected} wmode="opaque" width={"100%"} height={"400"} />
        );
      case "xml":
      case "csv":
      case "edi":
      case "vish":
        return <CodePreview source={this.props.elementSelected} />;
      default:
        return null;
    }
  }
}

MyFilesComponent.propTypes = {
  /**
   * Filter that indicates what types of files are shown. "*" means all.
   */
  show: PropTypes.any,
  /**
   * Files uploaded to server
   */
  filesUploaded: PropTypes.any,
  /**
   * Identifier of element whose source is being changed (box/slide background). It can be empty
   */
  idSelected: PropTypes.any,
  /**
   * Selected Element type
   */
  elementSelectedType: PropTypes.any,
  /**
   * Element selected from files
   */
  elementSelected: PropTypes.any,
  /**
   * Function that is called when the user selects an element
   */
  onElementSelected: PropTypes.func.isRequired,
  /**
   * Function for deleting files from server
   */
  deleteFileFromServer: PropTypes.func,
};
